import React, { useState, useEffect } from 'react'
import gsap from 'gsap'
import dayjs from 'dayjs'
import Days from '../Days'
import Months from '../Months'
import { SplitText } from 'gsap/dist/SplitText'

// import Heading from '../Heading'
type Input = {
  value: string | boolean | number
  setValue: (newValue) => void
}

const PlanningStepOne: React.FC<{
  input: Input[]
  variant: string
  noWeekend: boolean
}> = ({ input, variant, noWeekend }) => {
  const monthRef = React.useRef()
  const daysRef = React.useRef([])
  const [monthSTRef, setMonthSTRef] = useState(null)

  const [tl, setTl] = useState(null)
  const [month, setMonth] = useState(() => input[0].value)
  const [day, setDay] = useState(() => input[1].value)
  const [daysOfSelectedMonth, setDaysOfSelectedMonth] = useState([])

  useEffect(() => {
    input[1].setValue(day)
  }, [day])

  const now = dayjs()

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  const [monthName, setMonthName] = useState(null)

  const getDaysInMonth = (baseMonth: number) => {
    const dateToCheck = dayjs().month(baseMonth)
    const daysInCurrentMonth = dateToCheck.daysInMonth()
    const days = []
    for (let i = 1; i <= daysInCurrentMonth; i += 1) {
      const weekDay = dateToCheck.date(i).day()
      const isBeforeNow = dateToCheck.date(i).isBefore(dayjs())
      const isNow = dateToCheck.date(i).date() === dayjs().date()
      if (noWeekend) {
        if (weekDay % 6 && (isNow || !isBeforeNow)) {
          days.push({
            name: dateToCheck.date(i).format('dddd'),
            number: i < 10 ? `0${i}` : i,
          })
        }
      } else if (!isBeforeNow || isNow) {
        days.push({
          name: dateToCheck.date(i).format('dddd'),
          number: i < 10 ? `0${i}` : i,
        })
      }
    }
    return days
  }

  const setCurrentMonth = (currentMonth: string) => {
    const monthNumber = months.indexOf(currentMonth)
    setMonth(monthNumber)
    setMonthName(currentMonth)
    setDaysOfSelectedMonth(getDaysInMonth(monthNumber))
  }

  useEffect(() => {
    setDay(daysOfSelectedMonth[0]?.number)
  }, [daysOfSelectedMonth])

  useEffect(() => {
    setCurrentMonth(months[Number(month)])
    input[0].setValue(month)
  }, [month])

  const getTwelveMonthsFromNow = () => {
    const twelveMonthsFromNow = []

    let dateStart = dayjs()
    const dateEnd = dayjs().add(12, 'month')

    while (dateEnd.diff(dateStart, 'month') > 0) {
      twelveMonthsFromNow.push(months[parseInt(dateStart.format('M'), 10) - 1])
      dateStart = dateStart.add(1, 'month')
    }

    return twelveMonthsFromNow
  }

  const twelveMonthsFromNow = getTwelveMonthsFromNow()

  useEffect(() => {
    setTl(gsap.timeline({ repeat: 0 }))
    setMonthSTRef(
      new SplitText(monthRef.current, {
        type: 'words',
      }),
    )
  }, [])

  useEffect(() => {
    if (monthSTRef?.current) {
      tl.fromTo(
        daysRef.current.children,
        1,
        { y: 115 },
        { y: 0, stagger: 0.1, ease: 'circ.out' },
        0.2,
      )
      tl.fromTo(
        monthSTRef.current.words,
        1,
        { y: 115, opacity: 0 },
        { y: 0, opacity: 1, stagger: 0.1, ease: 'circ.out' },
        0.2,
      )
    }
  }, [monthSTRef])

  return (
    <>
      <Months
        variant={variant}
        months={twelveMonthsFromNow}
        setMonth={setCurrentMonth}
        selectedMonth={monthName}
        ref={monthRef}
      />
      <Days
        variant={variant}
        days={daysOfSelectedMonth}
        setDay={setDay}
        selectedDay={Number(day)}
        ref={daysRef}
      />
    </>
  )
}

export default PlanningStepOne
